jQuery(document).ready(function ($) {
  $(document).ready(function ($) {
    $(document).on('click', '.summary-header', function () {
      var $accordion = $(this).closest('.product__accordion');

      // agar sirf ek hi active hona chahiye to pehle sabse hatao
      $('.product__accordion').not($accordion).removeClass('active');

      // current wale ko toggle karo
      $accordion.toggleClass('active');
    });
  });

  $(document).ready(function () {
    var $input = $('.date-input');
    var $placeholder = $('.placeholder-date');
    var previousValue = '';

    function isSafariMobile() {
      return (
        /iP(hone|od|ad)/.test(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
      );
    }

    function togglePlaceholder() {
      if ($input.val()) {
        $placeholder.hide();
      } else {
        $placeholder.show();
      }
    }

    if (isSafariMobile()) {
      togglePlaceholder();
      setInterval(function () {
        if ($input.val() !== previousValue) {
          previousValue = $input.val();
          togglePlaceholder();
        }
      }, 300);
    }
  });

  $(document).ready(function () {
    var $returnPreview = $('.return-product-preview');

    if ($('.drawer').hasClass('active')) {
      $returnPreview.addClass('d-none');
    } else {
      $returnPreview.removeClass('d-none');
    }
  });

  $(document).ready(function () {
    var video = document.getElementById('trainingVideo');
    var playIcon = $('#playIcon');

    // force video to load first frame
    video.load();

    playIcon.on('click', function () {
      video.play();
      $(this).hide(); // play button hide ho jaye
    });
  });

  // $(document).ready(function () {
  //   var $mainProduct = $('.main-product-page');
  //   var $returnPreview = $('.return-product-preview');

  //   $returnPreview.hide(); // by default hidden

  //   $(window).on('scroll', function () {
  //     var mainBottom = $mainProduct.offset().top + $mainProduct.outerHeight();
  //     var scrollBottom = $(window).scrollTop() + $(window).height();

  //     if (scrollBottom >= mainBottom) {
  //       $returnPreview.fadeIn(); // show when main product finished
  //     } else {
  //       $returnPreview.fadeOut(); // hide before that
  //     }
  //   });
  // });
  $(document).ready(function () {
    var $mainProduct = $('.main-product-page');
    var $returnPreview = $('.return-product-preview');

    $returnPreview.hide(); // hide by default

    // Only run if main product exists
    if ($mainProduct.length) {
      $(window).on('scroll', function () {
        var mainOffset = $mainProduct.offset();
        if (!mainOffset) return; // safety check

        var mainBottom = mainOffset.top + $mainProduct.outerHeight();
        var scrollBottom = $(window).scrollTop() + $(window).height();

        if (scrollBottom >= mainBottom) {
          $returnPreview.fadeIn(); // show when main product finished
        } else {
          $returnPreview.fadeOut(); // hide before that
        }
      });
    }
  });

  $(document).ready(function ($) {
    const $slider = $('.paired-products-slider');

    // (Re)init safely if this code can run more than once
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    // Slick config: allow drag/swipe but keep it less sensitive
    $slider.slick({
      dots: false,
      infinite: true,
      speed: 350,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      draggable: true, // mouse drag
      swipe: true, // touch/trackpad gesture
      touchMove: true,
      touchThreshold: 25, // higher = less sensitive (default 5)
      swipeToSlide: false, // require full slide distance
      edgeFriction: 0.35, // adds a bit of resistance
      cssEase: 'ease',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    // --- Trackpad/mouse wheel support with throttling ---
    // This converts horizontal scroll gestures into prev/next with low sensitivity.
    const el = $slider.get(0);
    if (el) {
      let accum = 0;
      let lastFired = 0;
      const FIRE_INTERVAL_MS = 1000; // cooldown between slides
      const DELTA_THRESHOLD = 400; // how much horizontal delta before sliding

      // Use addEventListener so we can mark passive:false and call preventDefault
      el.addEventListener(
        'wheel',
        function (e) {
          // Prefer horizontal scroll; fall back to Shift+vertical if user does that
          const dx = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.shiftKey ? e.deltaY : 0;
          if (!dx) return;

          // Only act when the pointer is over the slider
          // (optional guard if your page has other scrollers)
          const now = Date.now();
          accum += dx;

          // Stop the page from doing native sideways scroll while we’re handling it
          e.preventDefault();

          // Fire only when threshold + cooldown satisfied
          if (Math.abs(accum) >= DELTA_THRESHOLD && now - lastFired >= FIRE_INTERVAL_MS) {
            if (accum > 0) {
              $slider.slick('slickNext');
            } else {
              $slider.slick('slickPrev');
            }
            lastFired = now;
            accum = 0; // reset after firing
          }
        },
        { passive: false }
      );
    }
  });
  $(document).ready(function ($) {
    function toggleVacancyClass() {
      if ($('.vacancy-enquiry').hasClass('show')) {
        $('body').addClass('vacancy-active');
      } else {
        $('body').removeClass('vacancy-active');
      }
    }
    const observer = new MutationObserver(toggleVacancyClass);

    observer.observe(document.querySelector('.vacancy-enquiry'), {
      attributes: true,
      attributeFilter: ['class'],
    });
    toggleVacancyClass();
  });

  $(document).ready(function ($) {
    function addUploadBox() {
      var $fbFile = $('.vacancies-enquiry-form-wrapper .fb-file');

      if ($fbFile.length && !$fbFile.find('.upload-wrapper').length) {
        var uploadBox = `
        <div class="upload-wrapper d-flex align-items-center justify-content-center">
          <div class="upload-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.999" height="17.999" viewBox="0 0 17.999 17.999">
              <g transform="translate(-0.001)">
                <path d="M8.589,18.811a3.15,3.15,0,0,1-.509-.174l-2.74,2.74a1.972,1.972,0,1,1-2.789-2.789L6.734,14.4a1.8,1.8,0,0,1,.641-.418A.734.734,0,0,1,7.62,13.9a1.35,1.35,0,0,1,.342-.063,1.993,1.993,0,0,1,.788.091,2.06,2.06,0,0,1,.774.481,1.882,1.882,0,0,1,.425.634c.014,0,.035-.007.049-.007a.965.965,0,0,0,.572-.279l.955-.955a4.037,4.037,0,0,0-.607-.788,3.934,3.934,0,0,0-1.771-1.018,1.723,1.723,0,0,0-.2-.049A.813.813,0,0,0,8.68,11.9a2.153,2.153,0,0,0-.223-.028.01.01,0,0,0-.014,0,1.587,1.587,0,0,0-.362-.014,3.839,3.839,0,0,0-.5.035H7.571l-.2.028a4.468,4.468,0,0,0-1.025.356,3.888,3.888,0,0,0-1.011.732L1.156,17.193a3.944,3.944,0,1,0,5.578,5.578l3.835-3.835A5,5,0,0,1,8.589,18.811Z" transform="translate(0 -5.928)" fill="#862633"/>
                <path d="M23.32,1.156a3.943,3.943,0,0,0-5.578,0L13.907,4.991a5.023,5.023,0,0,1,2.5.286L19.136,2.55a1.972,1.972,0,1,1,2.789,2.789L19.2,8.065l-.39.39-.4.4-.669.669a1.935,1.935,0,0,1-1.178.565,2.017,2.017,0,0,1-.5-.014,1.536,1.536,0,0,1-.474-.126,1.972,1.972,0,0,1-1.06-1.06.987.987,0,0,0-.621.286l-.955.955a3.857,3.857,0,0,0,1.395,1.395,2.912,2.912,0,0,0,.467.23,2.838,2.838,0,0,0,.516.181,3.937,3.937,0,0,0,2.8-.286,3.868,3.868,0,0,0,.711-.46l.007-.007c.1-.084.2-.174.293-.265l.349-.349L23.32,6.734a3.943,3.943,0,0,0,0-5.578Z" transform="translate(-6.476 0)" fill="#862633"/>
              </g>
            </svg>
          </div>
          <p class="upload-text mb-0 sailec-normal font16 leading20 spacing_032 text-black mb-0 res-font14 res-spacing_028">
            Click to upload or drag CV & Cover letter here
          </p>
        </div>
      `;
        $fbFile.append(uploadBox);
        var $fileInput = $fbFile.find('input[type="file"]');
        $fileInput.on('change', function () {
          if (this.files && this.files.length > 0) {
            var fileName = this.files[0].name;
            $fbFile
              .find('.upload-wrapper')
              .html(
                `<p class="uploaded-file-name mb-0 sailec-normal font16 leading20 spacing_032 text-black mb-0 res-font14 res-spacing_028">${fileName}</p>`
              );
          }
        });
      }
    }
    var target = document.querySelector('.vacancies-enquiry-form-wrapper');
    if (target) {
      var observer = new MutationObserver(addUploadBox);
      observer.observe(target, { childList: true, subtree: true });
    }
    addUploadBox();
  });

  // ✅ Shopify currency symbol dynamically
  // function formatMoney(cents) {
  //   if (typeof Shopify !== 'undefined' && Shopify?.currency?.active) {
  //     return Shopify.formatMoney
  //       ? Shopify.formatMoney(cents, Shopify.money_format)
  //       : Shopify.currency.active + (cents / 100).toFixed(2);
  //   }
  //   return '$' + (cents / 100).toFixed(2);
  // }
  $(document).ready(function ($) {
    var showChar = 260; // kitne characters default dikhane hain

    $('.collection-hero__description').each(function () {
      var content = $(this).html();

      // Agar content ki length showChar se zyada hai, tabhi Read More aur Read Less ka logic apply karo
      if (content.length > showChar) {
        var visibleText = content.substr(0, showChar);
        var hiddenText = content.substr(showChar);

        var html =
          visibleText + '<span class="morecontent"><span style="display:none;">' + hiddenText + '</span></span>';
        $(this).html(html);
      } else {
        // Agar content chhota hai, toh "Read More" button ko hata do
        $(this).next('.toggle-desc').remove();
      }
    });

    $('.toggle-desc').click(function () {
      var $desc = $(this).prev('.collection-hero__description').find('.morecontent span');
      if ($desc.is(':visible')) {
        $desc.hide();
        $(this).text('Read More');
      } else {
        $desc.show();
        $(this).text('Read Less');
      }
    });
  });

  // ✅ Variant Selection & Price Update
  // $(document).on('click', '.product-variant-btn', function () {
  //   var $btn = $(this);
  //   var $card = $btn.closest('.trending-product-card');

  //   $card.find('.product-variant-btn').removeClass('active');
  //   $btn.addClass('active');

  //   var variantPrice = $btn.data('variant-price');
  //   $card.find('.product-price').html(variantPrice); // <-- changed to html()

  //   var variantId = $btn.data('variant-id');
  //   $card.find('.add-to-bag-btn').data('variant-id', variantId);
  // });

  // ✅ Add to Bag
  $(document).on('click', '.add-to-bag-btn', function (e) {
    // Don't intercept the localization modal's submit button
    if ($(this).closest('#LocalizationModalForm').length > 0) {
      return; // Let the form submit naturally
    }
    
    e.preventDefault();
    var $btn = $(this);
    var variantId = $btn.data('variant-id');

    if (!variantId) {
      alert('Please select a variant first!');
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variantId, quantity: 1 },
      dataType: 'json',
      success: function () {
        updateCartAndDrawer();
        showToast('Added to bag!');
      },
      // error: function () {
      //   showToast('Error adding to bag.', true);
      // },
      error: function (xhr) {
        let response = {};
        try {
          response = JSON.parse(xhr.responseText);
        } catch (e) {
          response = { message: 'Unknown error occurred.' };
        }
        showToast(`❌ ${response.message}`, true);
      },
    });
  });

  // ✅ Add All Products to Bag (Safe & Clean)
  $(document).on('click', '.product-banner-section .add-all-to-bag-btn', function (e) {
    e.preventDefault();

    var $btn = $(this);
    var originalLabel = $btn.data('original-label') || $btn.text();

    // Prevent multiple clicks
    if ($btn.hasClass('is-adding')) return;
    $btn.addClass('is-adding').text('Adding...');

    // ✅ Get variant IDs safely
    var ids = $btn.data('variants');
    if (typeof ids === 'string') {
      ids = ids
        .split(',')
        .map(function (id) {
          return id.trim();
        })
        .filter(Boolean);
    }

    if (!Array.isArray(ids) || ids.length === 0) {
      showToast('⚠️ No products found.', true);
      $btn.removeClass('is-adding').text(originalLabel);
      return;
    }

    // ✅ Recursive add-to-cart function
    function addNext(i) {
      if (i >= ids.length) {
        updateCartAndDrawer();
        showToast('✅ All products added!');
        resetButton();
        return;
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { id: ids[i], quantity: 1 },
        dataType: 'json',
        success: function () {
          addNext(i + 1);
        },
        error: function () {
          showToast('❌ Error adding some items', true);
          resetButton();
        },
      });
    }

    // ✅ Reset button state
    function resetButton() {
      $btn.removeClass('is-adding').text(originalLabel);
    }

    // Start process
    addNext(0);
  });

  // ✅ Update Cart Count & Refresh Drawer
  function updateCartAndDrawer() {
    $.getJSON('/cart.js', function (cart) {
      // Update header counter
      $('.cart-number').text(cart.item_count);

      // Refresh drawer
      $.get('/cart', function (data) {
        var $newDrawerInner = $(data).find('.drawer__inner');
        if ($newDrawerInner.length) {
          var $drawerInner = $('.drawer__inner');
          $drawerInner.html($newDrawerInner.html());

          // Correctly update 'is-empty' class on cart drawer
          var $cartDrawer = $('.drawer'); // ensure correct element
          if ($cartDrawer.length) {
            if (cart.item_count > 0) {
              $cartDrawer.removeClass('is-empty'); // ✅ remove
            } else {
              $cartDrawer.addClass('is-empty'); // ✅ add
            }
          }

          // Optional: re-initialize drawer JS if needed
          // if (typeof initDrawer === 'function') initDrawer();
        }
      });
    });
  }

  // ✅ Toast Notification
  function showToast(msg, error = false) {
    var toast = $('<div class="cart-toast ' + (error ? 'error' : '') + '">' + msg + '</div>');
    $('body').append(toast);
    setTimeout(function () {
      toast.fadeOut(400, function () {
        $(this).remove();
      });
    }, 2000);
  }

  // ✅ Footer signup form handling - now handled by Klaviyo embed

  // ✅ Footer toast
  function showFooterToast(msg, error = false) {
    var toast = $('<div class="cart-toast ' + (error ? 'error' : '') + '">' + msg + '</div>');
    $('body').append(toast);
    setTimeout(function () {
      toast.fadeOut(400, function () {
        $(this).remove();
      });
    }, 2000);
  }

  // ✅ Captcha relocate (removed - not needed for Klaviyo)

  // blog open post page ( add to bag click add bag )
  // $(document).on('click', '.add-to-bag-btn', function (e) {
  //   e.preventDefault();
  //   var $btn = $(this);
  //   var variantId = $btn.data('variant-id');

  //   if (!variantId) {
  //     alert('Please select a variant first!');
  //     return;
  //   }

  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: { id: variantId, quantity: 1 },
  //     dataType: 'json',
  //     success: function () {
  //       updateCartAndDrawer();
  //       showToast('Added to bag!');
  //     },
  //     // error: function () {
  //     //   showToast('Error adding to bag.', true);
  //     // },
  //     error: function (xhr) {
  //       let response = {};
  //       try {
  //         response = JSON.parse(xhr.responseText);
  //       } catch (e) {
  //         response = { message: 'Unknown error occurred.' };
  //       }
  //       showToast(`❌ ${response.message}`, true);
  //     },
  //   });
  // });

  // Blog filter
  jQuery(document).ready(function ($) {
    var $wrapper = $('#blog-wrapper');
    if (!$wrapper.length) return;
    var perPage = parseInt($wrapper.data('articles-per-page')) || 6;
    var $allCards = $wrapper.find('.blog-card');
    var $pagination = $('#pagination-wrapper');
    var currentCollection = $allCards;
    var currentPage = 1;
    // Ensure only one .blog-row exists
    if ($wrapper.find('.blog-row').length === 0) {
      $wrapper.prepend('<div class="blog-row"></div>');
    }
    var $row = $wrapper.find('.blog-row');
    // Show page
    function showPage(page) {
      $allCards.hide();
      var start = (page - 1) * perPage;
      var end = start + perPage;
      var $pageCards = currentCollection.slice(start, end);
      // Empty row
      $row.empty();
      $pageCards.slice(0, 3).each(function () {
        $(this).fadeIn(200).appendTo($row);
      });
      $pageCards.slice(3).each(function () {
        $(this).fadeIn(200).appendTo($wrapper);
      });
      currentPage = page;
      renderPagination();
    }
    // Render pagination
    function renderPagination() {
      var totalPages = Math.ceil(currentCollection.length / perPage);
      $pagination.empty();
      if (totalPages <= 1) return;
      var $ul = $('<ul class="pagination justify-content-center"></ul>');
      var prevDisabled = currentPage === 1 ? 'disabled' : '';
      $ul.append(
        '<li class="page-item ' +
          prevDisabled +
          '"><a class="page-link" href="#" data-page="' +
          (currentPage - 1) +
          '">Prev</a></li>'
      );
      for (var i = 1; i <= totalPages; i++) {
        var active = i === currentPage ? 'active' : '';
        $ul.append(
          '<li class="page-item ' + active + '"><a class="page-link" href="#" data-page="' + i + '">' + i + '</a></li>'
        );
      }
      var nextDisabled = currentPage === totalPages ? 'disabled' : '';
      $ul.append(
        '<li class="page-item ' +
          nextDisabled +
          '"><a class="page-link" href="#" data-page="' +
          (currentPage + 1) +
          '">Next</a></li>'
      );
      $pagination.append($ul);
    }
    // Pagination click
    $pagination.on('click', 'a.page-link', function (e) {
      e.preventDefault();
      var page = parseInt($(this).data('page'));
      if (!isNaN(page) && page >= 1 && page <= Math.ceil(currentCollection.length / perPage)) {
        showPage(page);
        $('html, body').animate({ scrollTop: $wrapper.offset().top - 50 }, 100);
      }
    });
    // Filter click
    $('.filter-button').on('click', '.filter-btn', function () {
      var filter = $(this).data('filter');
      $('.filter-btn').removeClass('active').attr('aria-pressed', 'false');
      $(this).addClass('active').attr('aria-pressed', 'true');
      if (filter === 'all') {
        currentCollection = $allCards;
      } else {
        currentCollection = $allCards.filter(function () {
          return $(this).data('blog').includes(filter);
        });
      }
      if (currentCollection.length === 0) {
        $allCards.hide();
        $pagination.empty();
        $row.empty();
      } else {
        showPage(1);
      }
      updateTagCounts();
    });
    // Update tag counts
    function updateTagCounts() {
      $('.filter-btn').each(function () {
        var filter = $(this).data('filter');
        var count =
          filter === 'all'
            ? $allCards.length
            : $allCards.filter(function () {
                return $(this).data('blog').includes(filter);
              }).length;
        var label = $(this)
          .text()
          .replace(/\[\d+\]/, '')
          .trim();
        // $(this).text(label + ' (' + count + ')');
        $(this).html(label + ' <sup class="blog-count-sup font10">(' + count + ')</sup>');
      });
    }
    // Initial load
    showPage(1);
    updateTagCounts();
  });

  // Faq filter searching
  $(document).ready(function () {
    var $searchInput = $('#faq-search');
    var $faqItems = $('.faq-accordion-section .accordion-wrapper');

    function normalizeText(str) {
      return str
        .toLowerCase()
        .replace(/[\u2018\u2019\u201A\u201B\u2032\u2035]/g, "'") // fancy quotes → '
        .replace(/[\u201C\u201D\u201E\u201F\u2033\u2036]/g, '"') // fancy double quotes → "
        .replace(/’/g, "'") // extra safety
        .trim();
    }

    $searchInput.on('keyup', function () {
      var query = normalizeText($(this).val());

      $faqItems.each(function () {
        var $item = $(this);
        var question = normalizeText($item.find('.closet-header').text());
        var answer = normalizeText($item.find('.closet-content').text());

        if (question.indexOf(query) !== -1 || answer.indexOf(query) !== -1) {
          $item.show();
        } else {
          $item.hide();
        }
      });
    });
  });

  // Product page variant stock update
  $(document).ready(function () {
    var $stockWrapper = $('#variant-stock-status');

    $(document).on('change', "[name='id']", function () {
      var variantId = $(this).val();
      var isAvailable = window.productVariantsStock[variantId];

      if (isAvailable) {
        $stockWrapper.html(
          '<span class="in-stock badge prefix sailec-normal sailec-normal font14 leading26 spacing_028 text-black">In Stock</span>'
        );
      } else {
        $stockWrapper.html(
          '<span class="out-stock badge prefix sailec-normal sailec-normal font14 leading26 spacing_028 text-black">Out of Stock</span>'
        );
      }
    });
  });

  // ✅ Product Page - Update Add to Cart Button Price
  $(document).ready(function () {
    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, Shopify.money_format);
      }
      return '£' + (cents / 100).toFixed(2); // fallback GBP
    }

    var $btn = $("[id^='ProductSubmitButton-']");
    var $qtyInput = $("input[name='quantity']");

    function updateButtonPrice() {
      var variantId = $("[name='id']").val();
      var qty = parseInt($qtyInput.val()) || 1;

      var variant = window.productVariants?.find((v) => v.id == variantId);
      if (!variant) return;

      var totalPrice = variant.price * qty;

      // ✅ Update button text after small delay to prevent Shopify overwrite
      if (variant.available) {
        setTimeout(function () {
          $btn.find('.btn-text').text('Add to bag');
        }, 10); // 50ms delay is enough
      } else {
        setTimeout(function () {
          $btn.find('.btn-text').text('Sold out');
        }, 10);
      }

      // ✅ Update price (with dash before)
      $btn.find('.btn-price').text(formatMoney(totalPrice) + ' - ');
      $('.return-product-price').text(formatMoney(totalPrice));
    }

    // ✅ On variant change
    $(document).on('change', "[name='id']", function () {
      $qtyInput.val(1); // reset qty
      updateButtonPrice();
    });

    // ✅ On qty change
    $(document).on('input change', "input[name='quantity']", updateButtonPrice);

    // ✅ Initial load
    updateButtonPrice();
  });

  // ✅ Klarna Installment Price Update
  jQuery(document).ready(function ($) {
    // ✅ Klarna Installment Price Update
    function updateKlarnaPrice() {
      var variantId = $("[name='id']").val();
      var qty = parseInt($("input[name='quantity']").val()) || 1;

      var variant = window.productVariants?.find((v) => v.id == variantId);
      if (!variant) return;

      var totalPrice = variant.price * qty; // price in cents
      var installment = totalPrice / 3;

      // Format the installment using Shopify formatMoney if available
      var formattedInstallment =
        typeof Shopify !== 'undefined' && Shopify.formatMoney
          ? Shopify.formatMoney(installment, Shopify.money_format)
          : '£' + (installment / 100).toFixed(2);

      // Update Klarna message
      $('.klarna-message').text('Make 3 payments of ' + formattedInstallment);
    }

    // ✅ Run on variant change
    $(document).on('change', "[name='id']", function () {
      updateKlarnaPrice();
    });

    // ✅ Run on quantity change
    $(document).on('input change', "input[name='quantity']", function () {
      updateKlarnaPrice();
    });

    // ✅ Initial load
    updateKlarnaPrice();
  });

  // Breadbrumb collections ( product open page)
  jQuery(document).ready(function ($) {
    function updateBreadcrumb() {
      var $collectionsLi = $('.breadcrumb-collections');
      var $productLi = $('.breadcrumb-product');

      // Parse collection JSON safely
      var collections = [];
      var rawJson = $collectionsLi.attr('data-collections');
      try {
        if (rawJson) {
          collections = JSON.parse(rawJson);
        }
      } catch (e) {
        console.error('Breadcrumb JSON parse error:', e, rawJson);
      }

      // Render collection links
      if (collections.length > 0) {
        var html = collections
          .map(function (coll) {
            return '<li><a href="/collections/' + coll.handle + '">' + coll.title + '</a></li>';
          })
          .join('');
        $collectionsLi.replaceWith(html); // replace placeholder
      } else {
        $collectionsLi.remove();
      }

      // Product title
      var productTitle = $productLi.data('product-title') || document.title;
      $productLi.text(productTitle);
    }

    updateBreadcrumb();
  });

  // ✅ Basket Upsell Add-to-Bag Logic
  jQuery(document).ready(function ($) {
    // Add single upsell product
    $(document).on('click', '.basket-upsell__add-btn', function (e) {
      e.preventDefault();
      var $btn = $(this);
      var variantId = $btn.data('variant-id');

      if (!variantId) {
        showToast('⚠️ No variant found for this product.', true);
        return;
      }

      $btn.prop('disabled', true).text('Adding...');

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { id: variantId, quantity: 1 },
        dataType: 'json',
        success: function () {
          if (typeof updateCartAndDrawer === 'function') {
            updateCartAndDrawer();
          }
          if (typeof showToast === 'function') {
            showToast('Added to bag!');
          }
          $btn.prop('disabled', false).text('Add to bag');
          $('.cart-drawer').addClass('is-open');
        },
        error: function () {
          if (typeof showToast === 'function') {
            showToast('❌ Error adding product.', true);
          }
          $btn.prop('disabled', false).text('Add to bag');
        },
      });
    });

    // Hide upsell when "No thanks" clicked
    $(document).on('click', '.basket-upsell__no-thanks', function () {
      var $drawer = $(this).closest('.drawer__upsell');
      $drawer.addClass('drawer__upsell--hidden');
      setTimeout(function () {
        $drawer.css('display', 'none');
      }, 400); // match transition duration
    });

    // Show upsell when cart icon clicked
    $(document).on('click', '#cart-icon-bubble', function (e) {
      e.preventDefault(); // prevent default navigation if needed
      var $drawer = $('.drawer__upsell');

      // Only show if cart has items and upsell exists
      if ($drawer.length && parseInt($drawer.data('cart-item-count')) > 0) {
        $drawer.css('display', 'block');

        // Remove hidden class to slide it in
        setTimeout(function () {
          $drawer.removeClass('drawer__upsell--hidden');
        }, 50); // slight delay for smooth transition
      }
    });
  });

  // ✅ Prodcut open ( spinner ) close btn
  $(document).ready(function () {
    // Delegate click to dynamically loaded buttons
    $(document).on('click', '.cart-product-close-btn .cart-remove-button', function (e) {
      var $button = $(this);
      var $icon = $button.find('.svg-wrapper');
      var $spinner = $button.find('.loading-spinner');

      // Show spinner, hide icon
      $icon.addClass('hidden-icon');
      $spinner.removeClass('hidden-icon');

      // Disable button to prevent double click
      $button.prop('disabled', true);

      // Listen for Shopify AJAX cart update
      $(document).one('cart:updated', function () {
        $spinner.addClass('hidden-icon');
        $icon.removeClass('hidden-icon');
        $button.prop('disabled', false);
      });
    });
  });

  // File Upload (Vacancies Form)
  jQuery(document).ready(function ($) {
    var $fileInput = $('.file-upload-input');
    var $textContainer = $('.file-msg');
    var $cvLinkInput = $('#cv_link'); // hidden input

    $fileInput.on('change', function () {
      if (this.files.length > 0) {
        var fileName = this.files[0].name;
        $textContainer.text(fileName);
        $cvLinkInput.val('Candidate uploaded file: ' + fileName);
      } else {
        $textContainer.text('Click to upload or drag CV & Cover letter here');
        $cvLinkInput.val('');
      }
    });
  });

  // // Heaven Traning Academy ( Filter )
  // jQuery(document).ready(function ($) {
  //   function applyFilters() {
  //     var selectedCategory = $('.filter-category:checked').val();
  //     var selectedMaxPrice = parseFloat($('.price-slider').val());

  //     $('.blog-item').each(function () {
  //       var tags = $(this).data('tags').toString().split(',');
  //       var price = parseFloat($(this).data('price'));

  //       var matchCategory = !selectedCategory || tags.includes(selectedCategory);
  //       var matchPrice = !selectedMaxPrice || price <= selectedMaxPrice;

  //       if (matchCategory && matchPrice) {
  //         $(this).show();
  //       } else {
  //         $(this).hide();
  //       }
  //     });

  //     $('#maxPrice').text(selectedMaxPrice);
  //   }

  //   $('.filter-category').on('change', function () {
  //     applyFilters();
  //   });

  //   $('.price-slider').on('input change', function () {
  //     applyFilters();
  //   });

  //   applyFilters(); // Initialize on page load
  // });

  // Heaven Training Academy ( Filter )
  jQuery(document).ready(function ($) {
    function applyFilters() {
      var selectedCategory = $('.filter-category:checked').val();
      var selectedMaxPrice = parseFloat($('.price-slider').val());

      $('.blog-item').each(function () {
        var tags = $(this).data('tags').toString().split(',');
        var price = parseFloat($(this).data('price'));

        // "View All" should show everything
        var matchCategory = selectedCategory === 'all' || tags.includes(selectedCategory);
        var matchPrice = !selectedMaxPrice || price <= selectedMaxPrice;

        if (matchCategory && matchPrice) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      $('#maxPrice').text(selectedMaxPrice);

      // Save selected category in localStorage
      localStorage.setItem('selectedCategory', selectedCategory);
    }

    // Restore saved category on page load
    var savedCategory = localStorage.getItem('selectedCategory');
    if (savedCategory) {
      $(`.filter-category[value="${savedCategory}"]`).prop('checked', true);
    } else {
      $('#tag-all').prop('checked', true); // default to "View All"
    }

    // Trigger filter on change
    $('.filter-category').on('change', function () {
      applyFilters();
    });

    $('.price-slider').on('input change', function () {
      applyFilters();
    });

    // Initial filter
    applyFilters();
  });

  // Video ( Traning Academy Post )
  $(document).ready(function () {
    const video = document.getElementById('trainingVideo');
    const playIcon = document.getElementById('playIcon');

    // play-icon click → play video + hide icon
    playIcon.addEventListener('click', function () {
      video.play();
      playIcon.style.display = 'none';
    });
  });

  /* =========****=========== */
  // catrgory product ( collection ) variation
  // $(document).on('click', '.product-variant-btn', function () {
  //   var $btn = $(this);
  //   var $card = $btn.closest('.collection-product');

  //   $card.find('.product-variant-btn').removeClass('active');
  //   $btn.addClass('active');

  //   var variantPrice = $btn.data('variant-price');
  //   $card.find('.product-price').html(variantPrice); // <-- changed to html()

  //   var variantId = $btn.data('variant-id');
  //   $card.find('.add-to-bag-btn').data('variant-id', variantId);
  // });

  // ✅ Global Variant Selection & Price Update
  $(document).on('click', '.product-variant-btn', function () {
    var $btn = $(this);
    // Find the closest product card (works for both collection and trending)
    var $card = $btn.closest('.collection-product, .trending-product-card');

    // Remove active class from all variant buttons in this card
    $card.find('.product-variant-btn').removeClass('active');
    $btn.addClass('active');

    // Update price with compare at price support
    var variantPrice = $btn.data('variant-price');
    var compareAtPrice = $btn.data('variant-compare-at-price');
    var priceHtml = '<span>' + variantPrice + '</span>';
    
    if (compareAtPrice && compareAtPrice !== variantPrice) {
      priceHtml += '<span class="text-decoration-line-through text-muted ms-2">' + compareAtPrice + '</span>';
    }
    
    $card.find('.product-price').html(priceHtml);

    // Update the variant ID on the Add to Bag button
    var variantId = $btn.data('variant-id');
    $card.find('.add-to-bag-btn').data('variant-id', variantId);
  });

  // custom block linl
  // $(document).ready(function () {
  //   var $blockWrapper = $('.custom-link-block-wrapper');
  //   if (!$blockWrapper.length) return;

  //   var position = parseInt($blockWrapper.find('.custom-link-block').data('position'));
  //   var $products = $('.collection-products .grid__item'); // adjust as per theme

  //   if ($products.length > 0) {
  //     if (position <= 0) {
  //       // 0 ya negative → insert before first product
  //       $products.first().before($blockWrapper);
  //     } else if (position <= $products.length) {
  //       // Normal case → insert after Nth product
  //       $products.eq(position - 1).after($blockWrapper);
  //     } else {
  //       // position > total → append after last product
  //       $products.last().after($blockWrapper);
  //     }
  //   }
  // });

  // custom block linl
  $(document).ready(function () {
    var $blockWrapper = $('.custom-link-block-wrapper');
    if (!$blockWrapper.length) return;

    var position = parseInt($blockWrapper.find('.custom-link-block').data('position'));
    var $products = $('.collection-products .grid__item'); // adjust selector as per theme
    var minProductCount = 5; // client requirement

    if ($products.length >= minProductCount) {
      // Show block only if product count >= minProductCount
      $blockWrapper.removeClass('custom-link-none');

      if (position <= 0) {
        $products.first().before($blockWrapper);
      } else if (position <= $products.length) {
        $products.eq(position - 1).after($blockWrapper);
      } else {
        $products.last().after($blockWrapper);
      }
    } else {
      // Hide block if product count < minProductCount
      $blockWrapper.addClass('custom-link-none');
    }
  });

  // Ensure DOM is ready ( cart page )
  $(document).ready(function () {
    // Step 1: Get parent of main-cart-list-wrapper
    var parent = $('.main-cart-list-wrapper').parent();

    // Step 2: Append footer section to same parent
    $('.main-cart-footer-section').appendTo(parent);
    $('.main-cart-list-wrapper .free_shipping_card').insertBefore('.main-cart-footer-section .page-width');

    $('.main-cart-list-wrapper').append($('#also-bought-app-block'));

    // $('.samplio_samples').insertAfter('.main-cart-footer-section .js-contents');
    $('.sampleProdBtnWrapper').insertAfter('.main-cart-footer-section .js-contents');
  });

  // --------------- Rewards only open collection page ---------------
  // jQuery(document).ready(function ($) {
  //   setTimeout(() => {
  //     var currentPath = window.location.pathname;
  //     if (currentPath === '/collections' || currentPath.startsWith('/collections/')) {
  //       $('#smile-ui-lite-launcher-frame-container').show();
  //     } else {
  //       $('#smile-ui-lite-launcher-frame-container').hide();
  //     }
  //   }, 1000);
  // });
  function toggleSmileButton() {
    var path = window.location.pathname;
    var $btn = $('#smile-ui-lite-launcher-frame-container');

    // If button not yet loaded, retry a limited number of times
    if (!$btn.length) {
      if (!window.smileRetryCount) window.smileRetryCount = 0;
      if (window.smileRetryCount < 50) {
        // max ~10 seconds
        window.smileRetryCount++;
        setTimeout(toggleSmileButton, 200);
      }
      return;
    }

    // Reset counter once button found
    window.smileRetryCount = 0;

    // If popup open — always keep visible
    if ($('body').hasClass('smile-launcher-open')) {
      $btn.show();
      return;
    }

    // Show only on /collections or /collections/... pages
    if (path === '/collections' || path.startsWith('/collections/')) {
      $btn.show();
    } else {
      $btn.hide();
    }
  }

  $(document).ready(function () {
    toggleSmileButton();

    // Watch for popup open/close
    const observer = new MutationObserver(toggleSmileButton);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  });

  // ----- Also Bought  Select to Pills ----------
  jQuery(document).ready(function ($) {
    let interval = setInterval(function () {
      $('.cbb-also-bought-product select').each(function () {
        var $select = $(this);

        if ($select.hasClass('variant-buttons-added')) return;

        $select.addClass('variant-buttons-added');
        var $wrapper = $('<div class="product-variant-options d-flex gap-2 mb-3"></div>');

        $select.find('option').each(function (index) {
          var $option = $(this);
          var $btn = $(
            '<button type="button" class="product-variant-btn sailec-normal font12 spacing_024 leading16 text-black px-3 py-1 border-prefix radius30 bg-transapernt d-inline-block"></button>'
          ).text($option.text());

          if ($option.is(':disabled')) {
            $btn.prop('disabled', true).addClass('disabled');
          }

          $btn.on('click', function () {
            if (!$btn.prop('disabled')) {
              $select.val($option.val());
              $select[0].dispatchEvent(new Event('change', { bubbles: true }));
              $btn.addClass('active').siblings().removeClass('active');
            }
          });

          $wrapper.append($btn);

          if (index === 0 && !$option.is(':disabled')) {
            $btn.addClass('active');
            $select.val($option.val());
            $select[0].dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        $select.after($wrapper).hide();
        // 🔹 Replace "Add to Cart" text with "Add to Bag"
        $('.cbb-also-bought-product .add-to-cart-btn, .cbb-also-bought-product button').each(function () {
          var $btn = $(this);
          if ($btn.text().trim().toLowerCase() === 'add to cart') {
            $btn.text('Add to bag');
          }
        });
        // 🔹 Remove currency code like "GBP" from price text
        // $('.cbb-also-bought-product-regular-price, .cbb-also-bought-product-price').each(function () {
        //   var text = $(this).text();
        //   // Remove GBP (and optional space before it)
        //   text = text.replace(/\s*GBP\s*/gi, '');
        //   $(this).text(text.trim());
        // });
      });
    }, 300);

    setTimeout(() => clearInterval(interval), 5000);
  });

  jQuery(document).ready(function ($) {
    function moveFooter() {
      if ($(window).width() <= 992) {
        $('.main-cart-footer-section').insertBefore('#also-bought-app-block');
      }
    }

    // Page load pe check karo
    moveFooter();

    // Window resize pe bhi check karo
    $(window).resize(function () {
      moveFooter();
    });
  });

  // preview top
  $(document).ready(function () {
    $('.preview-btn').on('click', function () {
      $(window).scrollTop(0);
    });
  });
  $(document).ready(function () {
    var $body = $('body');

    // Check if body has an ID (Shopify usually sets page handle like "page-about")
    var bodyId = $body.attr('id');

    // Case 1: Home Page
    if ($body.hasClass('template-index')) {
      $body.addClass('home-page-wrapper');
    }

    // Case 2: Static Pages (like About, Contact etc.)
    else if ($body.hasClass('template-page')) {
      var pageHandle = bodyId.replace('page-', '');
      $body.addClass(pageHandle + '-page-wrapper');
    }

    // Case 3: Collections
    else if ($body.hasClass('template-collection')) {
      // Shopify usually gives body id like "collection-handle"
      if (bodyId) {
        var collectionHandle = bodyId.replace('collection-', '');
        $body.addClass(collectionHandle + '-collection-page-wrapper');
      } else {
        $body.addClass('collection-page-wrapper');
      }
    }

    // Case 4: Product Page
    else if ($body.hasClass('template-product')) {
      if (bodyId) {
        var productHandle = bodyId.replace('product-', '');
        $body.addClass(productHandle + '-product-page-wrapper');
      } else {
        $body.addClass('product-page-wrapper');
      }
    }

    // Case 5: Cart Page
    else if ($body.hasClass('template-cart')) {
      $body.addClass('cart-page-wrapper');
    }

    // Case 6: Blog Page
    else if ($body.hasClass('template-blog')) {
      if (bodyId) {
        var blogHandle = bodyId.replace('blog-', '');
        $body.addClass(blogHandle + '-blog-page-wrapper');
      } else {
        $body.addClass('blog-page-wrapper');
      }
    }

    // Case 7: Article Page
    else if ($body.hasClass('template-article')) {
      $body.addClass('article-page-wrapper');
    }

    // Fallback: Default
    else {
      $body.addClass('default-page-wrapper');
    }
  });

  // Wishlist Page
  jQuery(document).ready(function ($) {
    setInterval(function () {
      $('.swym-storefront-layout-grid-item-add-to-cart-button').each(function () {
        var $btn = $(this);
        if ($btn.text().trim() === 'Add To Cart +' || $btn.text().trim() === 'Added To Cart') {
          $btn.text('Add To bag');
        }
      });
    }, 300); // 0.3 second interval
  });

  // Are you intrested Drawer
  // jQuery(document).ready(function ($) {
  //   const upsellDrawer = document.querySelector('.drawer__upsell');
  //   if (!upsellDrawer) return;

  //   function checkUpsell() {
  //     if ($('.drawer__upsell .basket-upsell__products .basket-upsell__item').length === 0) {
  //       $('.drawer__upsell').addClass('hidden-upsell'); // add class
  //       // console.log('Upsell hidden');
  //     } else {
  //       $('.drawer__upsell').removeClass('hidden-upsell');
  //       // console.log('Upsell shown');
  //     }
  //   }

  //   checkUpsell();

  //   const observer = new MutationObserver(function () {
  //     checkUpsell();
  //   });

  //   observer.observe(upsellDrawer, { childList: true, subtree: true });
  // });

  // Are you intrested Drawer
  jQuery(document).ready(function ($) {
    function toggleUpsellDrawer() {
      $('.drawer__upsell').each(function () {
        const $drawer = $(this);
        const hasItems = $drawer.find('.basket-upsell__products .basket-upsell__item').length > 0;

        if (hasItems) {
          $drawer.removeClass('d-none hidden-upsell').show();
        } else {
          $drawer.addClass('d-none hidden-upsell').hide();
        }
      });
    }

    // Initial check
    toggleUpsellDrawer();

    // Listen to cart updates
    $(document).on('cart:updated cart:change drawer:updated ajaxSuccess', toggleUpsellDrawer);
  });
  $('#create_customer ul li').each(function () {
    var text = $(this).text().trim();
    if (text.includes('This email address is already associated with an account')) {
      $(this).text('This email address is already associated with an account.');
    }
  });
});
